export default "__VITE_ASSET__CDJNJYqp__"